export const css = {
	root: 'mlqVBUVK',
	scoreContainer: 'NmljtF_-',
	title: '_2kMGE5Qd',
	wrapper: '_3yYYNYfZ',
	domain: '_1k-hgirH',
	field: '_16bK7rIT',
	bar: '_3C6bVULX',
	lowScore: '_2h_86XDW',
	midScore: '_2ZaN5rF0',
	highScore: '_1Bygo2y8',
	barZero: '_15wBtwKW',
	barLow: '_29a-2EYB',
	barMid: '_3CN7-u7r',
	barHigh: '_2UAi-MPT',
	barscore: '_2xAPNVX7',
	legend: '_3bg2pUJ1',
	' _key': 'apic-theme/apic/prepost-viz/progress-viz'
};

export default css;
